export default __webpack_public_path__ + "static/media/arrow-right.956d575c.svg";